import React, { useEffect, useRef, useState } from "react";
import "leaflet/dist/leaflet.css";
import "react-leaflet-markercluster/dist/styles.min.css";
import { MapConsumer, MapContainer, Marker, TileLayer, GeoJSON, Popup } from "react-leaflet";
import SliderForZoom from "../SliderForZoom/SliderForZoom";
import MarkerClusterGroup from "react-leaflet-markercluster";
import L from "leaflet";
import axios from "axios";
import { isMobile } from "react-device-detect";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getSingleLocationData, setFilterResults } from "../../actions/filterAction";
import { MENU_CONTENT } from "../../constants";
import { useDispatch, useSelector } from "react-redux";
import { setAction, getApiProducts, setApiResponse, setTab, setUserLocation, getMapDetails, setLoader } from "../../actions/mainAction";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/react";
import { useParams } from "react-router-dom";
import "leaflet/dist/leaflet.css"
import "leaflet-geometryutil"
import nrmGeoJson from "../../GeoJsonData/nrm-pipelines-new.json";
import Legend from "../Legends";
import CardComponent from "./PinDialogCard/CardComponent";

const geoJSONStyle = {
  color: process.env.REACT_APP_GEOJSON_PIPELINES_COLOR || "#5C9979",
  weight: 2,
};
const override = css`
  position: absolute;
  z-index: 9999;
  top: 50%;
`;

function Map({ onOpenModal }) {
  const dispatch = useDispatch();
  const popupRef = useRef([]);
  const [mapDragging, setMapDragging] = useState(true);
  const [data, setData] = useState([]);
  const [filterAddress, setFilterAddress] = useState([]);
  const [map, setMap] = useState(null);
  let [zoom, setZoomLevel] = useState(13);
  const [products, setProducts] = useState([]);
  const [position, setPosition] = useState(null);
  const [kmClicked, setKmClicked] = useState(true);
  const [previousAddresses, setPreviousAddresses] = useState([]);
  const [selectProduct, setSelectProduct] = useState(false);
  const [defaultCenter, setDefaultCenter] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState({});
  const center = [51.05011, -114.08529];
  const locationsRef = useRef([]);
  const [filterCities, setFilterCities] = useState([]);
  const { filter, filterResults } = useSelector((state) => state.filters);
  const { tab, action, loader, currentLocation } = useSelector(
    (state) => state.main
  );
  const [localLoader, setLocalLoader] = useState(false);
  const params = useParams();
  const [popupMainPhoneNumberList, setPopupMainPhoneNumberList] = useState([]);
  const [topCustomersList, setTopCustomersList] = useState([]);
  const [phoneNumberCount, setPhoneNumberCount] = useState(0);

  useEffect(() => {
    dispatch(getApiProducts());
    dispatch(getMapDetails());
  }, []);

  useEffect(() => {
    if (tab.id === "location-detail" && tab.detail) {
      setPopupMainPhoneNumberList(tab.detail.mainLine?.split(";"));
      setTopCustomersList(tab.detail.topCustomers?.split(";"));
      setPhoneNumberCount(tab.detail.security ? 4 : 3);
      fitBounds(tab.detail);
      setTimeout(() => {
        if (tab.detail?.p_id) {
          popupRef.current[tab.detail.p_id]?.openOn(map);
        }
      }, [800]);
    }
    if (!tab?.id) {
      map?.closePopup();
    }
    setLocalLoader(false);
  }, [tab]);

  useEffect(() => {
    if (action.status === "near-me" && action.item === "near-me") {
      navigateToUserLocation(false);
      dispatch(setAction({ status: null, item: null }));
    }
  }, [action]);

  useEffect(() => {
    let tempCity = data.filter((lc) => {
      let fCity = filterCities.filter((tCity) => {
        return (
          tCity.localeCompare(lc.city, undefined, { sensitivity: "base" }) === 0
        );
      });
      return fCity.length > 0;
    });
    if (filterCities.length > 0) {
      sortLocationOnDistance(tempCity);
    } else {
      sortLocationOnDistance(data);
    }
  }, [filterCities]);

  useEffect(() => {
    locationsRef.current = locationsRef.current.slice(0, data.length);
  }, [data]);

  useEffect(() => {
    dispatch(setLoader(true));
    setFilterAddress(filterResults);
    let markers = [];
    filterResults.forEach((item) => {
      markers.push(L.marker([item.latitude, item.longtitude]));
    });
    let markersGroup = new L.featureGroup(markers);
    if (markersGroup.getBounds().isValid()) {
      map.fitBounds(
        markersGroup.getBounds(),
        isMobile === true ? { paddingTopLeft: [200, 0] } : { padding: [20, 20] }
      );
      map.setMaxZoom(18);
    }
    dispatch(setAction({ status: null, item: null }));
    dispatch(setLoader(false));
  }, [filterResults]);

  useEffect(() => {
    if (map) {
      navigateToUserLocation();
      if (isMobile)
        map.on("click", (e) => {
          dispatch(setTab({ id: "close-panel", detail: "close-panel" }));
        });
    }
  }, [map]);

  const getLocationData = (loc = null) => {
    dispatch(setLoader(true));
    try {
      axios
        .get(
          `${process.env.REACT_APP_API}MapLocations/GetAllLocations?brand=${
            process.env.REACT_APP_BRAND
          }&longlat=${loc?.lng ?? 0},${loc?.lat ?? 0}`,
          {
            headers: {
              ...(process.env.REACT_APP_OCPAPIMSUBKEY && {
                "Ocp-Apim-Subscription-Key":
                  process.env.REACT_APP_OCPAPIMSUBKEY,
              }),
              Accept: "application/json, text/plain, */*",
            },
          }
        )
        .then((res) => {
          if (res?.data) {
            setData(res?.data);
            sortLocationOnDistance(res?.data);
            dispatch(setApiResponse(res?.data));
            dispatch(setFilterResults(res?.data));
          } else notify();
          // !isMobile && leftSideBarHandlerRef.current.click();
          dispatch(setLoader(false));
        })
        .catch((error) => {
          notify();
          dispatch(setLoader(false));
        });
    } catch (e) {
      notify();
      dispatch(setLoader(false));
    }
  };

  useEffect(() => {
    // resolve the marker display issue
    const L = require("leaflet");

    delete L.Icon.Default.prototype._getIconUrl;

    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
      iconUrl: require("leaflet/dist/images/marker-icon.png"),
      shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
    });
  }, []);

  // return location stlyes for clustered feature with count on center of circle
  const createClusterCustomIcon = function (cluster) {
    let mrkr = cluster.getAllChildMarkers();
    let clusterClass = "default-height";

    if (cluster.getChildCount() < 10) clusterClass = "single-figure";
    else if (cluster.getChildCount() >= 10 && cluster.getChildCount() < 100)
      clusterClass = "double-figure";
    else if (cluster.getChildCount() >= 100 && cluster.getChildCount() < 1000)
      clusterClass = "triple-figure";
    else if (cluster.getChildCount() >= 1000) clusterClass = "four-figure";

    let productList = [...mrkr[0].options.data.products];
    let temp = [];
    mrkr.forEach((mr) => {
      if (
        checkAvailablilityHelper(mr.options.data.pos, productList) === false
      ) {
        temp.push(mr.options.data.pos);
      }
    });
    return L.divIcon({
      html: `<span>${cluster.getChildCount()}</span>`,
      className:
        "marker-cluster-custom " +
        process.env.REACT_APP_STOCK +
        " " +
        clusterClass,
      iconSize: L.point(60, 60, true),
    });
  };
  // return location stlyes with empty centered circle
  const createCustomIcon = L.divIcon({
    html: `<span></span>`,
    className: "marker-cluster-custom " + process.env.REACT_APP_STOCK,
    iconSize: [25, 25],
    iconAnchor: [3, 15],
    popupAnchor: [29, -15],
  });
  const createCustomIconPurple = L.divIcon({
    html: `<span></span>`,
    className: "marker-cluster-custom purple",
    iconSize: new L.Point([60, 60]),
    // iconAnchor: [10, 41],
    popupAnchor: [30, 0],
  });
  const selectedIconGrey = L.divIcon({
    html: `<span></span>`,
    className: "selected-marker purple" + process.env.REACT_APP_OUT_OF_STOCK,
    iconSize: new L.Point([60, 60]),
    // iconAnchor: [10, 41],
    popupAnchor: [30, 0],
  });

  const selectedIconGreen = L.divIcon({
    html: `<span></span>`,
    className: "selected-marker purple " + process.env.REACT_APP_STOCK,
    iconSize: new L.Point([60, 60]),
    // iconAnchor: [10, 41],
    popupAnchor: [30, 0],
  });
  // return location stlyes along with black centered circle
  const createCustomIconDisabled = L.divIcon({
    html: `<span></span>`,
    className: "marker-cluster-custom " + process.env.REACT_APP_OUT_OF_STOCK,
    iconSize: [25, 25],
    iconAnchor: [3, 15],
  });

  const CurrentLocationIcon = L.divIcon({
    html: `<span></span>`,
    className: process.env.REACT_APP_CURRENT_LOCATION,
    iconSize: [50, 50],
  });

  useEffect(() => {
    sortLocationOnDistance(data, "LocationFilterUpdate");
    setPreviousAddresses(data);
  }, [position, data, kmClicked]);

  const dataHandler = () => {
    setKmClicked(false);
  };

  const fitBounds = (lc, id) => {
    id === null ? setSelectedLocation(lc) : setSelectedLocation({});
    const latitude = +lc.latitude;
    const longtitude = +lc.longtitude;
    if (!latitude || !longtitude) {
      // FIXME - till api is not stable -> then remove this
      return;
    }
    let group = L.featureGroup(
      lc.type && lc.type === "click"
        ? L.marker([latitude, longtitude])
        : [L.marker([latitude, longtitude])]
    );
    if (group.getBounds().isValid()) {
      map?.flyTo(
        [latitude, longtitude],
        map.getZoom() >= 16 ? map.getZoom() : 16,
        {
          ...(isMobile === true
            ? { paddingTopLeft: [200, 0] }
            : { padding: [20, 20] }),
        }
      );
      map?.setMaxZoom(18);
    }
  };
  const setMapZoom = (event, newZoom) => {
    if (zoom != newZoom) {
      setZoomLevel(newZoom);
      map.setZoom(newZoom);
    }
  };
  const plusMinusZoom = (trigerIcon) => {
    if (trigerIcon === "minus") {
      if (zoom > 1) {
        setZoomLevel(zoom - 1);
        map.setZoom(zoom - 1);
      }
    } else if (trigerIcon === "plus") {
      if (zoom < 18) {
        setZoomLevel(zoom + 1);
        map.setZoom(zoom + 1);
      }
    }
  };

  const sortLocationOnDistance = (locations, filterAddress = null) => {
    let centerPoint = L.latLng(center[0], center[1]);
    let temp = [];
    locations.map((loc) => {
      let dist = position
        ? position.distanceTo({ lat: loc.latitude, lng: loc.longtitude })
        : centerPoint.distanceTo({
            lat: loc.latitude,
            lng: loc.longtitude,
          });
      temp.push({ ...loc, dist });
    });
    const seen = new Set();
    const filteredArr = temp.filter((el) => {
      const duplicate = seen.has(el.p_id);
      seen.add(el.p_id);
      return !duplicate;
    });
    temp.sort((a, b) => a.dist - b.dist);
    setFilterAddress(temp);
    if (filterAddress) {
      // it updates redux store for filter panel
      let filterLocation = [];
      temp.forEach((item) => {
        filterLocation.push({
          id: item.p_id,
          name: item.name,
          type: "radio",
          value: false,
          detail: item,
        });
      });
      let filterOption = MENU_CONTENT.filter((item) => {
        if (item.id === "location") {
          item.data = filterLocation;
          return item;
        }
      });
      let updatedFilter = [...MENU_CONTENT];
      // dispatch(setFilters(updatedFilter))
    }
  };
  const navigateToUserLocation = (action = true) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        let loc = L.latLng(
          parseFloat(position.coords.latitude),
          parseFloat(position.coords.longitude)
        );
        //map.flyTo(loc, action ? map.getZoom() : 15);
        L.marker(
          [
            parseFloat(position.coords.latitude),
            parseFloat(position.coords.longitude),
          ],
          { icon: CurrentLocationIcon }
        ).addTo(map);
        setPosition(loc);
        dispatch(setUserLocation(loc));
        if (map) {
          //map.once("load moveend", function (e) {
          console.log("action:", action);
          if (
            action &&
            !new URL(window.location.href).searchParams.get("productName")
          ) {
            params.id ? console.log(params.id) : getLocationData(loc);
          }
          //});
        }
      },
      (error) => {
        console.log(error);
        switch (error.code) {
          // PERMISSION_DENIED
          case 1:
            if (
              action &&
              !new URL(window.location.href).searchParams.get("productName")
            ) {
              params.id ? console.log(params.id) : getLocationData();
            }
            console.log("Permission denied");
            // onOpenModal(true);
            break;
          // POSITION_UNAVAILABLE
          case 2:
            if (
              action &&
              !new URL(window.location.href).searchParams.get("productName")
            ) {
              params.id ? console.log(params.id) : getLocationData();
            }
            console.log("Permission allowed, location disabled");
            onOpenModal(true);
            break;
          // TIMEOUT
          case 3:
            // notify();
            // console.log("Permission allowed, timeout reached");
            getLocationData();
            break;
        }
      },
      {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      }
    );
  };
  const checkAvailablilityHelper = (pos, prd = null) => {
    if (!(pos && pos.products)) return;
    let te = [];
    let productList = [];
    products.length === 0
      ? (productList = [...prd])
      : (productList = [...products]);
    productList.map((v) => {
      pos.products.map((pr) => {
        if (
          v.name == pr.name &&
          pr.instockstatus === "In Stock" &&
          v.isActive === true
        ) {
          te.push(pr);
        }
      });
    });
    return te.length <= 0;
  };
  const directionHandler = (pos) => {
    onOpenModal(true);
  };
  const notify = () =>
    toast("An error has occurred please try again.", {
      position: "top-right",
      theme: "colored",
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });

  return (
    <div style={{ position: "relative" }} className="App">
      <Legend />
      <ClipLoader
        color={process.env.REACT_APP_ACTIVE}
        loading={loader || localLoader}
        css={override}
        size={50}
      />
      <MapContainer
        className="map-Div"
        center={center}
        zoom={zoom}
        maxZoom={18}
        minZoom={2}
        scrollWheelZoom={true}
        whenCreated={setMap}
      >
        <MapConsumer>
          {(map) => {
            map.locate();
            mapDragging ? map.dragging.enable() : map.dragging.disable();
            return null;
          }}
        </MapConsumer>
        <div className="left-right-wrapper">
          <div />
          <SliderForZoom
            setMapDragging={setMapDragging}
            zoom={zoom}
            setMapZoom={setMapZoom}
            plusMinusZoom={plusMinusZoom}
            navigateToUserLocation={navigateToUserLocation}
          />
        </div>
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url={`${process.env.REACT_APP_MAPBOX_URL}?access_token=${process.env.REACT_APP_MAPBOX_KEY}`}
        />
        <MarkerClusterGroup
          showCoverageOnHover={false}
          spiderfyDistanceMultiplier={2}
          iconCreateFunction={createClusterCustomIcon.bind(products)}
        >
          {filterResults &&
            filterResults.map((pos, index) => {
              return (
                <Marker
                  key={index}
                  position={[pos.latitude, pos.longtitude]}
                  icon={
                    pos.stockStatus === "Out of Stock"
                      ? pos.p_id === selectedLocation.p_id
                        ? selectedIconGrey
                        : createCustomIconDisabled
                      : pos.p_id === selectedLocation.p_id
                      ? selectedIconGreen
                      : createCustomIcon
                  }
                  data={{ pos, products }}
                  eventHandlers={{
                    click: (e) => {
                      e.target.closePopup();
                      setLocalLoader(true);
                      dispatch(
                        getSingleLocationData(
                          `longlat=${currentLocation?.lng ?? 0},${
                            currentLocation?.lat ?? 0
                          }&location=${encodeURIComponent(pos.name)}`,
                          "click"
                        )
                      );
                    },
                  }}
                >
                  <Popup
                    ref={(el) => (popupRef.current[pos.p_id] = el)}
                    className={
                      "location-direction " + process.env.REACT_APP_MODE_CLASS
                    }
                    onClose={() => {
                      if (pos.p_id !== selectedLocation.p_id) {
                        // if (locationsRef.current[pos.p_id])
                        // locationsRef.current[pos.p_id].click();
                        // setEnableClick(false);
                        // setSelectedLocation({});
                      }
                    }}
                  >
                    <CardComponent
                      tab={tab}
                      popupMainPhoneNumberList={popupMainPhoneNumberList}
                      topCustomersList={topCustomersList}
                      phoneNumberCount={phoneNumberCount}
                    />
                  </Popup>
                </Marker>
              );
            })}
        </MarkerClusterGroup>
        <GeoJSON data={nrmGeoJson.features} style={geoJSONStyle} />
      </MapContainer>
      <ToastContainer />
    </div>
  );
}

export default Map;
